import React from "react";
import styles from "./ui.module.scss";
import { useEventStore } from "../../store";
import Link from "next/link";

const EventRequirements = () => {
  const { eventData } = useEventStore();
  if (!eventData?.donors_requirements?.length) return null;

  return (
    <div className={styles.EventRequirements}>
      <h4 className={styles.EventRequirements_Title}>Требования к донору</h4>
      <div className={styles.EventRequirements_Content}>
        {eventData.donors_requirements.map((item) => (
          <EventRequirementItem
            text={item.requirement}
            key={`requirement_${item.id}`}
          />
        ))}
      </div>
      <div className={styles.EventRequirements_MedContainer}>
        <Link href={"/requirements/"}>
          <a target={"_blank"} className={styles.EventRequirements_MedLink}>
            <span>Медицинские противопоказания</span>
          </a>
        </Link>
      </div>
    </div>
  );
};

const EventRequirementItem = ({ text }: { text: string }) => {
  return (
    <div className={styles.EventRequirements_Content_Item}>
      <img src="/static/images/eventIcons/Check.svg" alt="Чек" />
      <span>{text}</span>
    </div>
  );
};

export default EventRequirements;
